import type { City } from './city';
import type { Vec } from '../destruction/structure';
import { prepareRail, railLayouts, RAIL_Y } from './rail';

/** A second actual service follows the outer avenue reservation and reaches
 * the airport frontage and power campus. The original five-stop line remains. */
export function prepareRailBranches(city: City): City {
  if (!city.strategic || railLayouts(city.rail).some((r) => r.id === 'county')) return city;
  const points: Vec[] = [];
  const line = (x: number, z: number, X: number, Z: number) => {
    const n = Math.ceil(Math.hypot(X - x, Z - z) / 26);
    for (let i = 0; i < n; i++)
      points.push({ x: x + ((X - x) * i) / n, y: RAIL_Y, z: z + ((Z - z) * i) / n });
  };
  const arc = (x: number, z: number, from: number) => {
    for (let i = 0; i < 8; i++) {
      const a = from + (i * Math.PI) / 16;
      points.push({ x: x + 8 * Math.cos(a), y: RAIL_Y, z: z + 8 * Math.sin(a) });
    }
  };
  line(-322, -310, 847, -310);
  arc(847, -302, -Math.PI / 2);
  line(855, -302, 855, 602);
  arc(847, 602, 0);
  line(847, 610, -322, 610);
  arc(-322, 602, Math.PI / 2);
  line(-330, 602, -330, -302);
  arc(-322, -302, Math.PI);
  prepareRail(city, {
    id: 'county',
    name: 'County & East Cape Line',
    points,
    stops: [
      ['county-exchange', 'Westmere Interchange · County platform', -330, -30],
      ['county-homes', 'Orchard Avenue', -330, 200],
      ['county-foundry', 'Foundry Works', -330, 470],
      ['county-waterfront', 'Linden Coastal Promenade', 170, 610],
      ['county-airport', 'Alder Terminal Frontage', 430, -310],
      ['county-control', 'East Cape Control & Staff', 855, -115],
      ['county-plant', 'East Cape Works & Receiving', 855, 405],
    ],
  });
  for (const r of railLayouts(city.rail))
    for (const station of r.stations)
      if (['station:campus', 'station:county-exchange'].includes(station.id))
        station.interchange = 'westmere';
  return city;
}
